import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateIPSetForm {
  public name: string = ''
  public type: string = ''
  public timeoutSupport: boolean = false
  public defaultTimeout: number = 0
  public commentsSupport: boolean = false
  public counters: boolean = false
  public skbInfo: boolean = false
  public hashSizeCheckbox: boolean = false
  public hashSize: number = 1024
  public maxElementsCheckbox: boolean = false
  public maxElements: number = 65536

  public listTypes: string[] = [
    'bitmap:ip',
    'bitmap:ip,mac',
    'bitmap:port',
    'hash:ip',
    'hash:net',
    'hash:ip,port',
    'hash:ip,port,ip',
    'hash:ip,port,net',
    'hash:net,port',
    'hash:net,iface',
    'list:set',
  ]

  public rules: { [name: string]: FormValidationFunction[] } = {
    nameRules: [
      (v: string) => !!v || 'Every list has to have a name',
      (v: string) => v.length >= 3 || 'Name has to be at least 3 characters',
    ],
    defaultTimeoutRules: [
      (v: number) => (!!v || v === 0) || 'Timeout has to have a value',
      (v: number) => !isNaN(v) || 'Invalid timeout value. Value has to be a number',
      (v: number) => v >= 0 || 'Invalid timeout value. Value has to be positive',
    ],
    typeRules: [
      (v: string) => !!v || 'List has to have a type',
      (v: string) => this.listTypes.indexOf(v) !== -1 || 'Invalid list type',
    ],
  }
}
